import { HTTP_STATUSES } from "@miplatform/constants";
import { IBidResponse, PlanStatus } from "@miplatform/types";
import { useBids } from "@mibuildweb/hooks";
import { CreateBidPayload } from "./CreateBids.types";

const getDefaultValues = (data: IBidResponse) => ({
  ...data,
  seriesGroupId: data.seriesGroupId ?? null,
  seriesId: data.seriesId ?? null,
  assigneeId: data.assigneeId ?? null,
  communityId: data.communityId ?? null,
  pipeBrand: data.pipeBrand ?? "",
  additionalFeatures: data.additionalFeatures ?? "",
  bidRequestId: data.bidRequestId ?? null,
  bidRequestIndex: data.bidRequestIndex ?? null,
  bidRequest: data.bidRequest ?? null,
  requirementIds: data.requirements?.map((r) => r.id) ?? [],
});

export const useCreateBidViewModel = ({
  reset = () => null,
}: UseCreateBidViewModelProps = {}) => {
  const {
    isLoading,
    bidDetails,
    getBidDetails,
    updateBid,
    updateBidStatus,
    updatePlanRequirements,
  } = useBids();

  const fetchBidDetails = async (bidId?: string) => {
    const response = await getBidDetails(bidId || "");
    if (response.status === HTTP_STATUSES.OK) {
      reset(getDefaultValues(response.data));
    }
  };

  const handleUpdateBid = async (
    data: CreateBidPayload,
    successText?: string
  ) => {
    const response = await updateBid(data, successText);
    if (response.status === HTTP_STATUSES.OK) {
      reset({
        ...getDefaultValues(response.data),
        requirementIds: data.requirementIds,
      });
      return true;
    }
    return false;
  };

  const handleUpdateBidStatus = async (
    bid: CreateBidPayload,
    status: PlanStatus
  ) => {
    const response = await updateBidStatus(bid, status);
    if (response.status === HTTP_STATUSES.OK) {
      reset(getDefaultValues(response.data));
      return true;
    }
    return false;
  };

  const handleUpdatePlanRequirements = (
    planId: string,
    requirementIds: string[]
  ) => updatePlanRequirements(planId, requirementIds);

  return {
    isLoading,
    bidDetails,
    fetchBidDetails,
    handleUpdateBid,
    handleUpdateBidStatus,
    handleUpdatePlanRequirements,
  };
};

interface UseCreateBidViewModelProps {
  reset?: (data: CreateBidPayload) => void;
}
